import sanitizeHtml from 'sanitize-html';
import { FORMS_ENGINE_RICH_TEXT_FIELD_TYPES } from '../../lib/form.utils';

const FormsViewFallbackAnswer = ({ type, value, label }) => {
  return (
    <div className="spo-a-forms-view-fallback-answer">
      <div className="a-input">
        <label className="a-input__label">{label}</label>
        <div className="a-input__wrapper">
          <p>
            {FORMS_ENGINE_RICH_TEXT_FIELD_TYPES.includes(type) ? (
              <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }}></div>
            ) : (
              value
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

const FormsViewFallback = ({ className = '', content = {} }) => {
  return (
    <div className={`spo-m-forms-view-fallback ${className}`}>
      <div className="spo-m-forms-view-fallback__answers u-margin-top">
        {Object.keys(content)?.map((fieldName) => (
          <FormsViewFallbackAnswer key={fieldName} {...(content?.[fieldName] ?? {})} />
        )) ?? null}
      </div>
    </div>
  );
};

export default FormsViewFallback;
